export default __webpack_public_path__ + "static/DGI-7e578f5d47dca7118e7773fb950c4680.png";